import createEscaper from "./_createEscaper.js";
import unescapeMap from "./_unescapeMap.js";

// Function for unescaping strings from HTML interpolation.
export default createEscaper(unescapeMap);